import React from 'react';
import { useLanguage, LANGUAGES } from '../context/LanguageContext';
import { Button } from './ui/button';
import { Globe, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const LanguageSelector = ({ align = 'end', className = '' }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={`text-muted-foreground hover:text-foreground h-8 w-8 sm:h-9 sm:w-9 ${className}`}
          data-testid="language-selector-trigger"
        >
          <Globe className="w-5 h-5" />
          <span className="sr-only">Select Language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-40 max-h-80 overflow-y-auto">
        {Object.entries(LANGUAGES).map(([code, name]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => setLanguage(code)}
            className={`cursor-pointer flex items-center justify-between ${language === code ? 'bg-secondary font-semibold' : ''}`}
          >
            <div className="flex items-center gap-2">
              <span>{name}</span>
            </div>
            {language === code && <Check className="w-4 h-4 text-green-500 shrink-0" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
